import services from 'services';

export default {
  list: async ({ commit }, shopId) => {
    const res = await services.HistoryService.list(shopId);
    commit('SET_LIST', res);
  },

  lastHistory: async ({ commit }, shopId) => {
    const res = await services.HistoryService.getLatestHistory(shopId);
    commit('LAST_HISTORY', res);
  },
};
